import { Directive, ElementRef } from '@angular/core';
import { Role } from '../../../types/shared/Role';
import { AuthService } from '../services/auth.service';
import { BaseRoleDirective } from './base-role.directive';

@Directive({
    selector: '[isAdmin]',
    standalone: true
})
export class IsAdminDirective extends BaseRoleDirective {

    constructor(authService: AuthService, el: ElementRef) {
        super(authService, el);
        this.role = Role.SAMPLE_STUDIO_ADMIN;
        this.checkRole();
    }
}